var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-result',{attrs:{"status":"404","title":_vm.$t('系统正在发布中，请稍等') + '…'},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.$t('返回')))])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }